import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { InstallationsMigrationStore } from '@store';

import { InstallationMigrationModalComponent } from '../installation-migration-modal/installation-migration-modal.component';

@Component({
  selector: 'app-installation-migration-error',
  templateUrl: './installation-migration-error-modal.component.html',
  styleUrls: ['./installation-migration-error-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationMigrationErrorModalComponent {
  @Output() retry = new EventEmitter();

  constructor(
    private installationsMigrationStore: InstallationsMigrationStore,
    private dialogRef: MatDialogRef<InstallationMigrationModalComponent>
  ) {}

  onClose(): void {
    this.installationsMigrationStore.clearCachedData();
    this.dialogRef.close();
  }

  onRetry(): void {
    this.retry.emit();
  }
}
